import { Location } from 'react-router-dom';
import { baseAdminURL, baseEmployeeURL, basePortalURL, baseRetailerURL } from '../../routes';
import { AccessStatus, AuthContextType } from '../jwt/JwtContext';

interface PermissionsAndBaseRoutePath {
  admin: boolean;
  shouldRedirect: boolean;
  path: string;
}

const locationHelpers = (location: Location) => {
  return {
    getBasePath: () => {
      return location.pathname.includes(baseAdminURL) ? baseAdminURL
          : location.pathname.includes(baseRetailerURL) ? baseRetailerURL
          : location.pathname.includes(baseEmployeeURL) ? baseEmployeeURL
          : basePortalURL;
    },
    getRedirectTo: () => {
      return location.hash && new URLSearchParams(location.hash.substring(1)).get('redirectTo');
    },
  };
};

export const getPermissionsAndBaseRoutePath = (ctx: AuthContextType, location: Location) => {
  const { getBasePath, getRedirectTo } = locationHelpers(location);

  const result: PermissionsAndBaseRoutePath = {
    admin: false,
    shouldRedirect: !location.pathname.includes(basePortalURL) && !location.pathname.includes(baseRetailerURL),
    path: getBasePath(),
  };

  // when user is not authenticated
  if (!ctx.isAuthenticated) {
    // set path to login page when user is not authenticated
    result.path = result.path.concat('/auth/login');

    return result;
  }

  if (!ctx.accessStatus || !ctx.accessStatus.length) {
    if (ctx.user) {
      ctx.logout(ctx.user.roles![0]).then();
    } else {
      ctx.logoutForAllPortals()
    }

    result.path = result.path.concat('/auth/login');

    return result;
  }

  const checkAccess = location.pathname.includes('/mfa/enable') || location.pathname.includes('/mfa/verify') || location.pathname.includes('/mfa/backup-codes');

  if (ctx.accessStatus === AccessStatus.MFA_REQUIRED) {
    const path = '/mfa/enable';

    result.shouldRedirect = !location.pathname.includes(path);
    result.path = baseAdminURL + path;
  } else if (ctx.accessStatus === AccessStatus.VERIFY_MFA) {
    const path = '/mfa/verify';

    result.shouldRedirect = !location.pathname.includes(path);
    result.path = baseAdminURL + path;
  } else if (ctx.accessStatus === AccessStatus.BACKUP_CODE_SAVE) {
    const path = '/mfa/backup-codes';

    result.shouldRedirect = !location.pathname.includes(path);
    result.path = baseAdminURL + path;
  } else {
    // when user is authenticated
    if (ctx.isAdmin) {
      result.admin = true;
      result.shouldRedirect = !location.pathname.includes(baseAdminURL) || checkAccess;

      result.path = `${baseAdminURL}/dashboard`;
    } else if (ctx.isSuperAdmin) {
      result.admin = true;
      result.shouldRedirect = !location.pathname.includes(baseAdminURL) || checkAccess;

      result.path = `${getBasePath()}/dashboard`;
    } else if (ctx.isRetailer) {
      result.shouldRedirect = !location.pathname.includes(baseRetailerURL) || checkAccess;
      result.admin = false;
      result.path = baseRetailerURL;
    } else if (ctx.isEmployee) {

      result.shouldRedirect = !location.pathname.includes(baseEmployeeURL) || checkAccess;
      result.admin = false;
      result.path = baseEmployeeURL;
    } else {

      result.admin = false;
      result.path = basePortalURL;
    }

    // get redirect-path from hash and set to path
    const redirectTo = getRedirectTo();
    if (redirectTo) {
      result.path = result.path.concat(`/${redirectTo}`);
    }
  }

  return result;
};
